import {
  CoreFormFieldSelect,
  CoreFormFieldSelectProps,
} from '@bambi/component-library/src/components/forms/fields/CoreFormFieldSelect';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

/**
 * This isn't a comprehensive list of all supported timezones, just the common ones in the US.
 */
export function TimezoneSelectFormField(
  props: Omit<CoreFormFieldSelectProps<string>, 'options'>
) {
  const options: SelectOption<string>[] = [
    { label: 'America/New_York', value: 'America/New_York' },
    { label: 'America/Los_Angeles', value: 'America/Los_Angeles' },
  ];

  return <CoreFormFieldSelect {...props} options={options} />;
}
